import React, { useEffect, useState } from "react";
import { useGetProfessionsWithServicesQuery } from "../../store/professions";
import AvatarImg from "../../images/Doctor-1.png";
import { scrollToTop } from "../../utilities/utils";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const ProfessionalCategories = ({ title, selectedProfession }) => {
  const [currentTab, setCurrentTab] = useState(1);
  const [tabs, setTabs] = useState([]);
  const [content, setContent] = useState([]);

  const { data: professionsData } = useGetProfessionsWithServicesQuery();

  const getContent = (tab) => {
    if (tab.name === "Mental Health Counselor") {
      return professionsData?.filter(({ parent_id }) => parent_id === tab.id);
    }
    return professionsData?.find(({ id }) => id === tab.id)?.professional_services;
  };

  useEffect(() => {
    const filteredTabs = professionsData?.filter(item => item.featured_in_homepage && !item.parent_id);
    setTabs(filteredTabs);
    if (filteredTabs?.length > 0) {
      const firstTab = filteredTabs[0];
      setCurrentTab(Number(firstTab.id));
      const content = filterAndSort(getContent(firstTab) ?? []);
      setContent(content);
      handleTabClick(firstTab);
    }
  }, [professionsData]);
  
  const filterAndSort = (data) => data
    .filter(({ featured_in_homepage }) => featured_in_homepage === 1)
    .sort((a, b) => (a.homepage_order ?? Infinity) - (b.homepage_order ?? Infinity))
    .slice(0, 6);
  
  const handleTabClick = (tab) => {
    setCurrentTab(Number(tab.id));
    const content = filterAndSort(getContent(tab) ?? []);
    setContent(content);
  };

  const handleProfessionalCategories = () => {
    selectedProfession(currentTab);
    scrollToTop();
  };

  return (
    <div className="container pb-[50px] md:pb-[100px]">
      <h2 className="mb-[30px] md:mb-[50px] text-center lg:text-left max-w-[270px] md:max-w-full mx-auto">
        {title}
      </h2>
      <div className="tabs overflow-auto mb-[40px] md:mb-[70px]">
        <div className="flex flex-row gap-[30px] xl:gap-[50px] border-b-[3px] border-solid border-[#F1F4F6] font-medium text-[20px] leading-[36px] max-lg:text-[14px] max-lg:leading-[22px] text-[#485868] w-[670px] md:w-[805px] lg:w-full">
          {tabs &&
            tabs.map((tab, i) => (
              <button
                style={
                  currentTab === tab.id
                    ? { color: "#1E90FE", borderBottom: "3px solid #1E90FE" }
                    : { color: "#485868" }
                }
                className="md:text-center pb-[14px] xl:pb-[20px] lg:pb-[14px] md:text-sm lg:text-base xl:text-xl bg-none border-solid mb-[-3px]"
                onClick={() => handleTabClick(tab)}
                key={i}
                id={tab.id}
                disabled={currentTab === tab.id}
              >
                {tab.name}
              </button>
            ))}
        </div>
      </div>
      <div className="grid grid-cols-6 gap-x-[20px] xl:gap-x-7 max-lg:grid-cols-3 max-sm:grid-cols-2 gap-y-[40px] lg:gap-y-[0]">
        {content.map((item) => (
          <div
            className="categories-list cursor-pointer"
            onClick={handleProfessionalCategories}
          >
            <div className="overflow-hidden max-h-[183px] max-w-[183px] rounded-[20px]">
              <img
                src={item.image ? `${baseUrl}storage/` + item.image : AvatarImg}
                alt="Profession Image"
                className="w-full h-auto min-h-[183px] object-cover"
              />
            </div>
            <p className="font-bold text-[16px] leading-[26px] -tracking-[0.5px] text-customGray mt-[20px]">
              {item.name ?? "test"}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfessionalCategories;
